import React, {useEffect} from 'react';

import './DialogOverlay.less';

//TODO mount animation

export const DialogOverlay = ({children, isBottomContents, onOverlayClick}) => {

	useEffect(() => {
		if (document.body.style.overflow === 'hidden') return;

		const initialOverflow = document.body.style.overflow;

		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = initialOverflow;
		}
	}, []);

	useEffect(() => {
		const activeElement = document.activeElement;
		const tagName = activeElement?.tagName.toLowerCase();
		if (tagName && ["input", "textarea"].includes(tagName)) {
			const y = activeElement.getBoundingClientRect().top + window.scrollY;
			window.scroll({
				top: y,
				behavior: "smooth"
			});
		}
	}, []);

	return (
		<div
			className={`dialog-overlay ${isBottomContents ? 'dialog-overlay--bottom-contents' : ''}`}
			onClick={e => e.target === e.currentTarget && typeof (onOverlayClick) === 'function' && onOverlayClick()}
		>
			<div className="dialog-overlay__content">
				{children}
			</div>
		</div>
	);
};
